import { AdminApp } from "./components/AdminApp";
import { AdminInvitationIntegration } from "./components/AdminInvitationIntegration";
import { LandingPage } from "./components/LandingPage";
import { LegalPage } from "./components/LegalPage";

function currentView() {
  return new URL(window.location.href).searchParams.get("view") ?? "landing";
}

export function viewUrl(view: "landing" | "admin" | "impressum" | "datenschutz") {
  const url = new URL(window.location.href);
  url.search = "";
  url.hash = "";
  if (view !== "landing") url.searchParams.set("view", view);
  return url.toString();
}

export default function App() {
  const view = currentView();
  if (view === "admin") {
    return (
      <>
        <AdminApp />
        <AdminInvitationIntegration />
      </>
    );
  }
  if (view === "impressum" || view === "datenschutz") return <LegalPage kind={view} />;
  return <LandingPage />;
}
